<template>
  <BaseMenu
    :use-close-btn="false"
    class="resume-conformity-progress-menu"
    :card-class="['resume-conformity-progress-menu__card', ...cardClasses]"
  >
    <template v-slot:activator="{ on }">
      <div class="cursor-pointer" v-on="on">
        <slot name="activator"></slot>
      </div>
    </template>

    <div class="resume-conformity-progress-menu__card-content">
      <div
        v-for="(item, index) in vacancyMatchDataList"
        :key="index"
        class="resume-conformity-progress-menu__card-content-row"
        :class="{ _gray: item.value === 0, _green: item.value > 0 }"
      >
        <div class="d-flex">
          <div class="content-row__icon-wrap">
            <BaseSvg v-if="item.value > 0" name="ico-check" width="1.7rem" height="1.2rem" />
            <span v-else style="font-size: 1.8rem;">?</span>
          </div>
          <div class="ml-2">{{ item.title }}</div>
        </div>
        <div class="content-row__value">{{ item.value ? `+ ${item.value}%` : item.value }}</div>
      </div>
    </div>
  </BaseMenu>
</template>

<script>
export default {
  name: 'ResumeConformityProgressMenu',
  props: {
    matchData: {
      type: Object,
      required: true,
    },
    bottom: {
      type: Boolean,
      default: false,
    },
    movedLeft: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    vacancyMatchDataList() {
      return Object.entries(this.matchData).map(([key, value]) => ({
        title: this.vacancyMatchDataTitle(key),
        value,
      }));
    },
    cardClasses() {
      const classes = [];
      if (this.movedLeft) classes.push('_moved-left');
      if (this.bottom) classes.push('_bottom');

      return classes;
    },
  },
  methods: {
    vacancyMatchDataTitle(key) {
      switch (key) {
        case 'gender': return this.$tMyResponses('Gender');
        case 'age': return this.$tMyResponses('Age');
        case 'ph_activity': return this.$tMyResponses('Physical activity');
        case 'specialization': return this.$tMyResponses('Profession / Specialization');
        case 'spheres': return this.$tMyResponses('Work direction');
        default: return key;
      }
    },
  },
};
</script>
